//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchUtils from '~/mixins/search/search-utils'

export default {
  name: 'SearchOtherBoatTypesInLocation',
  props: {
    isDestination: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    fixUnder (val) {
      const text = val.replace('_', ' ').toLowerCase()
      return text.charAt(0).toUpperCase() + text.slice(1)
    }
  },
  mixins: [searchUtils],
  computed: {
    routeType () {
      return this.isDestination ? 'destination-location-boat' : 'search_with_boat'
    },
    getBoatTypes () {
      return this.searchFilters?.boat_types
    },
    hasBoatTypes () {
      return !!this.getBoatTypes?.length
    }
  }
}
